'use strict';
import {getLogger} from 'loglevel';
import utilities from '../../js/utilities';
import NotificationBar from '../NotificationBar/NotificationBar';
import template from './templates/PerksNotificationBar.hbs';
import * as PerksService from '../../services/PerksService';
import {EnableHybrisIntegration} from '../../utilities/featureFlags';

const log = getLogger('Perks');

export default class PerksNotificationBar extends NotificationBar {
  initialize() {
    this.template = template;
    if (!EnableHybrisIntegration.isEnabled()) {
      PerksService.getPerksStatus()
        .then(data => {
          data.current = Math.floor(data.current)
          return data;
        })
        .then(this.show.bind(this))
        .catch(log.error);
    }
    else
    {
      PerksService.getHybrisPerksLevel()
        .then(data => {
          return data;
        })
        .then(this.show.bind(this))
        .catch(log.error);
    }
    super.initialize();
  }

  dismiss(e) {
    utilities.sessionStorageSave('hidePerksNotificationBar', true);
    super.dismiss(e);
  }

  /**
   * Check if the perks bar should display
   *
   * Should only display for logged in, non-MyArrow, non-blocked users
   *
   * @returns {Promise.<boolean>}
   */
  static shouldDisplay() {
    if (utilities.sessionStorageLoad('hidePerksNotificationBar')) {
      return Promise.resolve(false);
    }

    return PerksService.getPerksEligibility();
  }
}

/**
 * Create the PerksNotificationBar if needed
 *
 * @param {jQuery} $parent
 */
export function createPerksNotificationBar($parent) {
  let $notificationBar = $parent.find('#PerksNotificationBar');

  if ($notificationBar.length) {
    PerksNotificationBar.shouldDisplay()
      .then(shouldDisplay => {
        if (shouldDisplay) {
          new PerksNotificationBar({ el: $notificationBar })
        }
      });
  }
}



// WEBPACK FOOTER //
// ./assets/components/PerksNotificationBar/PerksNotificationBar.js